import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Home from './components/Home';
import Opensource from './components/Opensource';
import Services from './components/Services';
import './App.css';

function App() {
  return (
    <div className="App">
      <nav style={{
        backgroundColor: '#f8f9fa',
        padding: '1rem',
        borderBottom: '1px solid #ddd'
      }}>
        <ul style={{
          listStyle: 'none',
          display: 'flex',
          gap: '2rem',
          margin: 0,
          padding: 0
        }}>
          <li>
            <Link 
              to="/" 
              style={{
                textDecoration: 'none',
                color: '#007bff',
                fontSize: '1.1rem',
                fontWeight: '500'
              }}
            >
              Home
            </Link>
          </li>
          <li>
            <Link 
              to="/opensource" 
              style={{
                textDecoration: 'none',
                color: '#007bff',
                fontSize: '1.1rem',
                fontWeight: '500'
              }}
            >
              Open Source
            </Link>
          </li>
          <li>
            <Link 
              to="/services" 
              style={{
                textDecoration: 'none',
                color: '#007bff',
                fontSize: '1.1rem',
                fontWeight: '500'
              }}
            >
              Services
            </Link>
          </li>
        </ul>
      </nav>

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/opensource" element={<Opensource />} />
          <Route path="/services" element={<Services />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
